import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import moment from 'moment';
import cn from 'classnames';

import { Button } from 'components/Button';
import { formatCurrency } from 'utils/formatCurrency';

import styles from './styles.module.scss';

const PaymentSubmitted = () => {
  const navigate = useNavigate();
  const quickpayData = useSelector((state) => state.quickpay.data);
  const lastPayment = useSelector((state) => state.quickpay.lastPayment);
  const suggestAutopay = (quickpayData.autopays || []).length === 0 && quickpayData.suggestedAutopayNextApplyDate && quickpayData.suggestedAutopayAmount;

  const goToScheduleAutopay = () => navigate('/quickpay/enroll-autopay');

  const renderFromAccount = () => {
    if (lastPayment && lastPayment.paymentMethodCode === 'apple-pay') {
      return 'Apple Pay';
    }
    const allPaymentMethods = (quickpayData?.paymentAccounts || []).map((acc) => ({
      value: acc.accountId,
      title: `${(acc.accountType)} ${acc.category === 'bankcard' ? `xxxx-xxxx-xxxx-${acc.cardNumberLast4}` : `xxxx${acc.accountNumberLast4}`}`,
    }));
    const lastPaymentAccountId = lastPayment?.paymentAccountId;
    if (!lastPaymentAccountId) return '-';
    const selectedMethod = allPaymentMethods.find((acc) => acc.value === lastPaymentAccountId);
    return selectedMethod?.title;
  };

  const applyDate = get(lastPayment, 'applyDate') ? moment(get(lastPayment, 'applyDate')).format('MM/DD/YYYY').toString() : '-';
  const payedAmount = get(lastPayment, 'amount', 0) + get(lastPayment, 'fees', 0);

  return (
    <div className={cn(styles.quickpay, styles.paymentSubmitted)}>
      <div className={styles.content}>
        <h1>Thank you for your payment!</h1>
        <h1>Your payment has been submitted for processing</h1>
        <div className={cn(styles.paymentInfo, 'mt-2')}>
          <table>
            <tbody>
              <tr>
                <td>From Account</td>
                <td className={styles.paymentCell}>{renderFromAccount()}</td>
              </tr>
              <tr>
                <td>Date</td>
                <td>{applyDate}</td>
              </tr>
              <tr>
                <td>Amount</td>
                <td>
                  $
                  {formatCurrency(payedAmount, 2)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className={styles.stickyFooter}>
        {suggestAutopay ? (
          <div>
            <p>To make future payments easier, would you like to sign-up for AutoPay?</p>
            <Button
              color="primary"
              className="w-100 mt-1"
              onClick={goToScheduleAutopay}
            >
              YES - PROCEED TO SET UP AUTOPAY
            </Button>
          </div>
        ) : (
          <p className="text-center d-block mb-4">
            For your security, please close this
            <br />
            browser session
          </p>
        )}
      </div>
    </div>
  );
};

export default PaymentSubmitted;
